import React from 'react';
import {
	BlockHeading,
	SecondaryContentBlockWrapper,
	BlockContent,
	Stylediframe,
} from './SecondaryContentBlock.styles';

const SecondaryContentBlock = ({ title, body, columns, position, page }) => (
	<SecondaryContentBlockWrapper position={position}>
		<BlockHeading children={title} position={position} />
		{body !== undefined && (
			<BlockContent
				position={position}
				columns={columns}
				dangerouslySetInnerHTML={{
					__html: body,
				}}></BlockContent>
		)}
		<div>
			{page === 'contact' && (
				<Stylediframe
					src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2488.6588273643583!2d-0.04343458571720325!3d51.409323225692674!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487601a1f74a60af%3A0xb2b5fa1310da633d!2sTBR%20Floral%20Design!5e0!3m2!1sen!2ses!4v1615423440461!5m2!1sen!2ses"
					allowFullscreen=""
					loading="lazy"></Stylediframe>
			)}
		</div>
	</SecondaryContentBlockWrapper>
);

export default SecondaryContentBlock;
